export default __webpack_public_path__ + "static/media/03949c32e7f0ad087c546bbe0d65d457.svg";